const FORM_SELECTOR = "[data-contact-form]";
const ENDPOINT = "https://api.spamblock.io/f/tDMxkXoNqnbW";

function initForm(form: HTMLFormElement) {
  const success = document.querySelector<HTMLElement>("[data-contact-success]");
  const errorBox = document.querySelector<HTMLElement>("[data-contact-error]");
  const submitBtn = form.querySelector<HTMLButtonElement>("button[type='submit']");

  form.addEventListener("submit", async (e) => {
    e.preventDefault();
    if (errorBox) {
      errorBox.hidden = true;
      errorBox.textContent = "";
    }
    if (success) success.hidden = true;

    const consent = form.querySelector<HTMLInputElement>("input[name='consent']");
    if (consent && !consent.checked) {
      if (errorBox) {
        errorBox.hidden = false;
        errorBox.textContent = "Please accept the privacy notice to send a message.";
      }
      return;
    }

    const fd = new FormData(form);
    submitBtn?.setAttribute("disabled", "true");
    submitBtn?.classList.add("opacity-60");

    try {
      const res = await fetch(ENDPOINT, {
        method: "POST",
        body: fd,
        headers: {
          Accept: "application/json, text/html, */*",
        },
        mode: "cors",
      });

      const contentType = res.headers.get("content-type") || "";
      if (res.ok) {
        form.reset();
        if (success) success.hidden = false;
        return;
      }

      let message = `Request failed (${res.status}).`;
      if (contentType.includes("application/json")) {
        try {
          const data = (await res.json()) as { message?: string; error?: string };
          message = data.message || data.error || message;
        } catch {
          /* ignore */
        }
      } else {
        const text = await res.text();
        if (text) message = text.slice(0, 280);
      }
      if (errorBox) {
        errorBox.hidden = false;
        errorBox.textContent = message;
      }
    } catch {
      if (errorBox) {
        errorBox.hidden = false;
        errorBox.textContent =
          "Could not reach the form service from this browser. If the problem persists, email us directly.";
      }
    } finally {
      submitBtn?.removeAttribute("disabled");
      submitBtn?.classList.remove("opacity-60");
    }
  });
}

const form = document.querySelector<HTMLFormElement>(FORM_SELECTOR);
if (form) initForm(form);
